module.exports = ":host {\n  display: block; }\n\n.alert {\n  -webkit-box-shadow: 0 3px 4px -4px #000;\n  box-shadow: 0 3px 4px -4px #000; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/alert/alert.component.scss
// module id = ./src/app/common/alert/alert.component.scss
// module chunks = main